import React from 'react'

class Canvas extends React.Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
  }
  componentWillUpdate() {
    const {
      colorTwoR,
      colorTwoG,
      colorTwoA,
      colorTwoB,
      colorThreeR,
      colorThreeG,
      colorThreeA,
      colorThreeB,
      colorOneR,
      colorOneG,
      colorOneA,
      colorOneB
    } = this.props;
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext("2d");
    const width = canvas.width;
    const height = canvas.height;
    const grd = ctx.createLinearGradient(width, 0, width, height);

    grd.addColorStop(0, `rgba(${colorOneR},${colorOneG},${colorOneB},${colorOneA})`)
    grd.addColorStop(0.64, `rgba(${colorTwoR},${colorTwoG},${colorTwoB},${colorTwoA})`)
    grd.addColorStop(1.0, `rgba(${colorThreeR},${colorThreeG},${colorThreeB},${colorThreeA})`)
    ctx.fillStyle = grd;
    ctx.fillRect(0, 0, width * 2, height * 2);
    ctx.restore();

  }
  render() {
    return <canvas className='site__canvas abs x y' width={740} height={425} ref={this.canvasRef} />;
  }
}

export default Canvas